export default {
      id: "arrow-right-news-usage",
      viewBox: "0 0 10 16",
      url: __webpack_public_path__ + "img/icons.df848786.svg#arrow-right-news",
      toString: function () {
        return this.url;
      }
    }